import PropTypes from 'prop-types';
import React, { useState } from 'react';
import EditAddressModal from './EditAddressModal';
import EditableAddress from './EditableAddress';
import PopUp from 'react/shared/components/popups/PopUp';
import { possessiverize } from 'react/shared/utils/Strings';
import { USER_TYPES } from 'react/signups/card/recipes/constants';
import userTypeShape from 'react/signups/card/shapes/UserType';

export default function ManageAddressesModal({
  account,
  cardholderFirstName,
  onChangeAddress,
  onClose,
  organization,
  userType,
}) {
  const [showEditModal, setShowEditModal] = useState(false);
  const [shippingDestination, setShippingDestination] = useState(account.shippingDestination);
  const [addressToEdit, setAddressToEdit] = useState({});

  const otherAddress = {
    street1: '',
    street2: '',
    city: '',
    state: '',
    zip: '',
  };

  const handleEditAddress = (addressDetails, shippingDestination) => {
    setShippingDestination(shippingDestination);
    setAddressToEdit(addressDetails);
    setShowEditModal(true);
  };

  const handleSelectAddress = (addressDetails, shippingDestination) => {
    onChangeAddress(addressDetails, shippingDestination);
    onClose();
  };

  const handleBack = () => {
    setShowEditModal(false);
  };

  const handleFinishEditing = (editedAddress) => {
    onChangeAddress(editedAddress, shippingDestination);
    setShowEditModal(false);
    onClose();
  };

  return (
    <>
      {showEditModal && (
        <EditAddressModal
          address={addressToEdit}
          headerText={shippingDestination === 'other' ? 'Add new address' : 'Edit this address'}
          onBack={handleBack}
          onDone={handleFinishEditing}
          showPoBoxWarning={shippingDestination === 'cardholder_home'}
        />
      )}
      {!showEditModal && (
        <PopUp
          header="Where do you want the card shipped?"
          headerComponent={'h2'}
          onClose={onClose}
          openModal
          padding="30px"
        >
          {userType !== USER_TYPES.MYSELF && (
            <div data-testid="cardholder_home">
              <EditableAddress
                address={account.cardholder.address}
                name={`${possessiverize(cardholderFirstName)} Address`}
                onEdit={handleEditAddress}
                onSelect={handleSelectAddress}
                shippingDestination="cardholder_home"
              />
            </div>
          )}
          <div data-testid="office">
            <EditableAddress
              address={organization.address}
              name="My Address"
              onEdit={handleEditAddress}
              onSelect={handleSelectAddress}
              shippingDestination="office"
            />
          </div>
          <div data-testid="other">
            <EditableAddress
              address={otherAddress}
              name="Other"
              onEdit={handleEditAddress}
              shippingDestination="other"
            />
          </div>
        </PopUp>
      )}
    </>
  );
}

ManageAddressesModal.propTypes = {
  account: PropTypes.object.isRequired,
  cardholderFirstName: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  onChangeAddress: PropTypes.func.isRequired,
  organization: PropTypes.object.isRequired,
  userType: userTypeShape.isRequired,
};
